import React, { Component } from "react";
import Bestofferbanner from "./best-offers-banner";
import Topsellers from "./top-sellers";
import Newarrivals from "./new-arrivals";
import "./style.css";

export default class Home extends Component {
  render() {
    return (
      <div className="wrapper">
        <div className="fixed-banner">
          <Bestofferbanner />
        </div>
        <div className="content-home">
          {" "}
          <Topsellers />
          <Newarrivals />
        </div>
      </div>
    );
  }
}
